import { styled } from '@mui/material'

export const SignatureValue = styled('span')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 30,
  overflow: 'hidden',
})
